module.exports = __webpack_public_path__ + "img/hibou_livre.e02d7b0d.png";